















import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import CodeExampleBody from '@/components/docs-main/code-rails-view/CodeExampleBody.vue';
import GlobalBus from '@/plugins/GlobalBus';
import { GlobalBusNames, StoreMutations } from '@/templates/DataNames';
import { Getter, Mutation, State } from 'vuex-class';
import { convertToAnchorIdHelper } from '@/heplers/stringHelpers';

interface codeExample {
  [id: string]: {
    title: string;
    sources: {
      [id: string]: string;
    };
  };
}

@Component({
  components: {
    CodeExampleBody,
  },
})
export default class CodeRails extends Vue {
  @Prop() layoutHeight: string;
  @Getter('getContent') data: any;
  @State('pageRendered') pageRendered: boolean;
  @Mutation(StoreMutations.SET_STATUS_OF_PAGEINCLUDESCODEEXAMPLES)
  mutateStatusOfPageIncludeExamples: (status: boolean) => void;
  public currentExample = '';
  public examples: codeExample = {};
  public isLoadedSdksOverflow = false;
  private timeout: any = null;

  get isExamplesInclude() {
    const status: boolean = Object.keys(this.examples).length > 0;
    this.mutateStatusOfPageIncludeExamples(status);
    return status;
  }

  /**
   * Собираем объект для Examples
   */

  mounted() {
    this.bindInitMethods();
  }

  beforeDestroy() {
    this.isLoadedSdksOverflow = false;

    clearTimeout(this.timeout);
  }

  @Watch('pageRendered')
  onPageRenderedChanged(val: boolean) {
    this.isLoadedSdksOverflow = false;
    clearTimeout(this.timeout);
    if (val) this.bindInitMethods();
  }

  bindInitMethods() {
    GlobalBus.off(GlobalBusNames.CHANGEEXAMPLE);
    this.setCodeExamples();
    this.checkLoadedOverflow();
  }

  // Проверяем есть ли у последнего примера кода в sdk ширина, т.е. отрендерилось ли оно. Если да, то закрываем все примеры кода кроме нужного. Ставим максимальное кол-во попыток в 10
  checkLoadedOverflow() {
    let lastKey: any = Object.keys(this.examples);
    lastKey = 'code-example__' + lastKey[lastKey.length - 1];
    let counter = 0;
    let timer = setInterval(() => {
      let elm: any = document.getElementById(lastKey);

      counter++;
      if (!elm) return;

      elm = elm.querySelector('.sdk-tabs');

      elm = elm?.offsetWidth;

      if (elm) {
        this.timeout = setTimeout(() => (this.isLoadedSdksOverflow = true), 200);
        clearInterval(timer);
      }

      if (counter > 10) clearInterval(timer);
    }, 500);
  }

  convertToAnchorId(title: string) {
    return this.$route.meta.fqdn + '_' + convertToAnchorIdHelper(title);
  }

  public checkCurrentExample(index: string): boolean {
    return this.currentExample === index;
  }

  private computeExamples() {
    if (!this.data) return {};

    if (!this.data.content && !this.data.children) return {};

    let content = [];

    if (this.data.content) {
      content = this.data.content.filter((dataInfo: any) => {
        if (dataInfo.kind === 'content_source') return dataInfo.examples.length;
      });
    } else if (this.data.children) {
      content = this.data.children
        .filter((method: any) => {
          // eslint-disable-next-line no-prototype-builtins
          if (method.hasOwnProperty('examples')) return method.examples.examples.length;
        })
        .map((method: any) => method.examples);
    }

    return content.reduce((acc: any, child: any, index: number) => {
      return {
        ...acc,
        ...{ [this.convertToAnchorId(child.title) + '_' + index]: child },
      };
    }, {});
  }

  private setCodeExamples() {
    this.examples = this.computeExamples();
    this.currentExample = Object.keys(this.examples)[0];
    GlobalBus.on(GlobalBusNames.CHANGEEXAMPLE, (id: string) => {
      setTimeout(() => {
        let elm = document.getElementById(`code-example__${this.currentExample}`);

        if (!elm) return;

        elm = elm.querySelector('.code__tab.active');

        if (elm) elm.scrollIntoView({ inline: 'center' });
      }, 0);
      this.currentExample = this.$route.meta.fqdn + '_' + id;
    });
  }
}
